var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "user-icon_svg__a",
    d: "M8 11.25a7.508 7.508 0 017.5 7.5.5.5 0 01-.5.5H1a.5.5 0 01-.5-.5 7.508 7.508 0 017.5-7.5zM8 .75a4.75 4.75 0 110 9.5 4.75 4.75 0 010-9.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#EEF4FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2h24v24H2z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#647A97",
    fillRule: "nonzero",
    xlinkHref: "#user-icon_svg__a",
    transform: "translate(6 4)"
  }))));
}
export default SvgUserIcon;